import { useEffect, useRef, useState } from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginSuccess } from '../redux/authSlice';
import { localizedErrorMessage } from '../utils/italianErrorMessage';

function PortalSso() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const started = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const callbackError = params.get('error');
    window.history.replaceState({}, document.title, '/sso');

    if (callbackError) {
      setError(localizedErrorMessage(callbackError, 'Accesso non riuscito.'));
      return;
    }

    if (!code) {
      setError('Codice di accesso mancante.');
      return;
    }

    fetch('/api/auth/sso/exchange', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    })
      .then(async (response) => {
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.error || 'Accesso dal portale non riuscito.');
        return data;
      })
      .then((data) => {
        dispatch(loginSuccess(data));
        if (data.user?.id) localStorage.setItem('id', data.user.id);
        const destination = String(data.tenantType).toUpperCase() === 'SALE_CONGRESSI'
          ? '/prenotazione'
          : '/landing_page';
        navigate(destination, { replace: true });
      })
      .catch((err) => setError(localizedErrorMessage(err, 'Accesso non riuscito.')));
  }, [dispatch, location.search, navigate]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 3 }}>
      {error ? <Alert severity="error">{error}</Alert> : (
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>Accesso dal portale in corso...</Typography>
        </Box>
      )}
    </Box>
  );
}

export default PortalSso;
